import { Component, Input, forwardRef, ChangeDetectorRef } from '@angular/core';
import { ControlValueAccessor, FormGroup, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-check-box',
  templateUrl: './check-box.component.html',
  styleUrls: ['./check-box.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CheckBoxComponent),
      multi: true,
    },
  ],
})
export class CheckBoxComponent implements ControlValueAccessor {
  @Input() label: string;
  @Input() formControlName: string;
  @Input() frm: FormGroup;
  modelo: boolean = false;

  constructor(private cdr: ChangeDetectorRef) {}

  onChange: any = () => { };
  onTouched: any = () => { };

  get value() {
    return this.modelo;
  }

  set value(val: boolean) {
    this.modelo = val;
    this.onChange(val);
    this.onTouched();
    this.cdr.detectChanges(); 
  }

  writeValue(value: boolean): void {
    this.value = value ?? false;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
}
